import React, {useMemo} from "react"
import memo from "set-state-compare/build/memo"
import {View} from "react-native"

const WrappedList = ({style, ...restProps}) => {
  const viewStyle = useMemo(() => Object.assign({flex: 1, flexDirection: "row", flexWrap: "wrap"}, style), [style])

  return (
    <View style={viewStyle} {...restProps} />
  )
}

export default memo(WrappedList)
